document.addEventListener('DOMContentLoaded', () => {
    function setTouchedClass(event, flipcardItem) {
        if (flipcardItem) {
            if (!flipcardItem.classList.contains('flipcard-touched')) {
                flipcardItem.classList.add('flipcard-touched', 'touch-active');
            } else {
                flipcardItem.classList.remove('flipcard-touched');
            }
        }
    }

    // init tab navigation for accessibility (tab trough and trigger hover animation on enter)
    function initTabNavigation() {
        const flipcardItems = document.querySelectorAll('.flipcarditem');

        flipcardItems.forEach((flipcardItem) => {
            flipcardItem.addEventListener('focus', () => {
                flipcardItem.addEventListener('keydown', (event) => {
                    // enter
                    if (event.which === 13) {
                        setTouchedClass(event, flipcardItem);
                    }
                });
            });
        });
    }

    if ('ontouchstart' in window || navigator.maxTouchPoints) {
        document.addEventListener('touchstart', (event) => {
            setTouchedClass(event, event.target.closest('.flipcarditem'));
        }, { passive: true });
    } else {
        initTabNavigation();
    }
});
